import {
  AMOUNT_DEFAULT_FORMAT,
  PERCENTAGE_FORMAT,
} from "@/constants/currency-format.constants";
import moment from "moment";
import numeral from "numeral";
import Vue from "vue";

const formatCurrency = Vue.filter("formatCurrency", (val, format) => {
  return "£" + numeral(val).format(format || AMOUNT_DEFAULT_FORMAT);
});

const formatDecimal = Vue.filter("formatDecimal", (val, format) => {
  return numeral(val).format(format || AMOUNT_DEFAULT_FORMAT);
});

const formatPercent = Vue.filter(
  "formatPercent",
  (val, format = PERCENTAGE_FORMAT) => {
    return numeral(val).format(format) + "%";
  }
);
const timeFormat12h = Vue.filter("timeFormat12h", (time) => {
  return moment(time, "hh:mm:ss").format("h.mma");
});

export default {
  formatCurrency,
  formatDecimal,
  formatPercent,
  timeFormat12h,
};
